import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../Styles/ManageGallery.css";

function ManageGallery({ view = "all" }) {

  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);

  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  // ================= EDIT =================

  const [editingId, setEditingId] = useState(null);

  const [editData, setEditData] = useState({
    title: "",
    description: ""
  });

  const [editFile, setEditFile] = useState(null);

  // ================= LOAD GALLERY =================

  const loadGallery = async () => {

    try {

      const [imageResponse, videoResponse] =
        await Promise.all([

          axios.get(
            "/api/gallery/images"
          ),

          axios.get(
            "/api/gallery/videos"
          )

        ]);

      setImages(imageResponse.data);
      setVideos(videoResponse.data);
      setSelectedImages([]);

    } catch (error) {

      console.error(
        "Error loading gallery:",
        error
      );

      alert("Unable to load gallery");

    }

  };

  // ================= LOAD WHEN PAGE OPENS =================

  useEffect(() => {

    loadGallery();

  }, []);

  // ================= SELECT PHOTO =================

  const handleSelectImage = (id) => {

    setSelectedImages((prev) => {

      if (prev.includes(id)) {

        return prev.filter(
          (imageId) => imageId !== id
        );

      }

      return [...prev, id];

    });

  };

  // ================= OPEN PHOTO =================

  const handleOpenPhoto = (image) => {

    // Do not open preview while editing
    if (editingId === image.id) {
      return;
    }

    setSelectedPhoto(image);

  };

  // ================= CLOSE PHOTO =================

  const handleClosePhoto = () => {

    setSelectedPhoto(null);

  };

  // ================= NEXT PHOTO =================

  const handleNextPhoto = () => {

    if (!selectedPhoto || images.length === 0) {
      return;
    }

    const currentIndex = images.findIndex(
      (image) => image.id === selectedPhoto.id
    );

    const nextIndex =
      (currentIndex + 1) % images.length;

    setSelectedPhoto(images[nextIndex]);

  };

  // ================= PREVIOUS PHOTO =================

  const handlePreviousPhoto = () => {

    if (!selectedPhoto || images.length === 0) {
      return;
    }

    const currentIndex = images.findIndex(
      (image) => image.id === selectedPhoto.id
    );

    const previousIndex =
      (currentIndex - 1 + images.length) %
      images.length;

    setSelectedPhoto(images[previousIndex]);

  };

  // ================= START EDIT =================

  const handleEdit = (item) => {

    setEditingId(item.id);

    setEditData({
      title: item.title || "",
      description: item.description || ""
    });

    setEditFile(null);

  };

  // ================= EDIT TEXT CHANGE =================

  const handleEditChange = (e) => {

    const { name, value } = e.target;

    setEditData((prev) => ({
      ...prev,
      [name]: value
    }));

  };

  // ================= EDIT FILE CHANGE =================

  const handleEditFileChange = (e) => {

    if (
      e.target.files &&
      e.target.files.length > 0
    ) {

      setEditFile(e.target.files[0]);

    } else {

      setEditFile(null);

    }

  };

  // ================= SAVE EDIT =================

  const handleSaveEdit = async (id) => {

    try {

      const formData = new FormData();

      formData.append(
        "title",
        editData.title
      );

      formData.append(
        "description",
        editData.description
      );

      // New file is optional
      if (editFile) {

        formData.append(
          "file",
          editFile
        );

      }

      await axios.put(
        `/api/gallery/${id}`,
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

      alert(
        "Gallery item updated successfully."
      );

      setEditingId(null);
      setEditFile(null);

      setEditData({
        title: "",
        description: ""
      });

      await loadGallery();

    } catch (error) {

      console.error(
        "Update gallery error:",
        error
      );

      alert(
        "Update failed.\n\nPlease check Spring Boot."
      );

    }

  };

  // ================= CANCEL EDIT =================

  const handleCancelEdit = () => {

    setEditingId(null);

    setEditFile(null);

    setEditData({
      title: "",
      description: ""
    });

  };

  // ================= DELETE SELECTED PHOTOS =================

  const handleDeleteSelected = async () => {

    if (selectedImages.length === 0) {

      alert(
        "Please select at least one photo."
      );

      return;

    }

    const confirmed = window.confirm(
      `Are you sure you want to delete ${selectedImages.length} selected photo(s)?`
    );

    if (!confirmed) {
      return;
    }

    try {

      await Promise.all(

        selectedImages.map((id) =>
          axios.delete(
            `/api/gallery/${id}`
          )
        )

      );

      alert(
        "Selected photo(s) deleted successfully."
      );

      setSelectedPhoto(null);

      loadGallery();

    } catch (error) {

      console.error(
        "Delete selected photos error:",
        error
      );

      alert(
        "Delete failed.\n\nPlease check Spring Boot."
      );

    }

  };

  // ================= DELETE VIDEO =================

  const handleDelete = async (id, type) => {

    const confirmed = window.confirm(
      `Are you sure you want to delete this ${type}?`
    );

    if (!confirmed) {
      return;
    }

    try {

      await axios.delete(
        `/api/gallery/${id}`
      );

      alert(
        `${type.charAt(0).toUpperCase() + type.slice(1)} deleted successfully`
      );

      loadGallery();

    } catch (error) {

      console.error(
        "Delete error:",
        error
      );

      alert(
        "Delete failed.\n\nPlease check Spring Boot."
      );

    }

  };

  // ================= PAGE =================

  return (

    <div className="manage-gallery-container">

      {/* ================= HEADER ================= */}

      <div className="manage-gallery-header">

        <h2>
          {view === "photos"
            ? "📷 Manage Photos"
            : view === "videos"
            ? "🎥 Manage Videos"
            : "🖼️ Manage Gallery"}
        </h2>

{/* <button
          className="back-btn"
          onClick={() => navigate("dashboard")}
                  >
          ← Back to Dashboard
        </button> */}
       

      </div>

      {/* ================= PHOTOS ================= */}

      {view !== "videos" && (

        <section className="gallery-section">

          {images.length === 0 ? (

            <p className="empty-message">
              No photos available.
            </p>

          ) : (

            <>

              {/* DELETE SELECTED */}

              <button
                className="delete-selected-btn"
                onClick={handleDeleteSelected}
                disabled={
                  selectedImages.length === 0
                }
              >
                🗑 Delete Selected
              </button>

              <div className="manage-gallery-grid">

                {images.map((image) => (

                  <div
                    className="manage-gallery-card"
                    key={image.id}
                  >

                    {/* PHOTO */}

                    <div className="media-container">

                      <img
                        src={`${image.fileUrl}`}
                        alt={image.title}
                        className="gallery-photo"
                        onClick={() =>
                          handleOpenPhoto(image)
                        }
                      />

                      {/* CHECKBOX */}

                      <input
                        type="checkbox"
                        className="photo-select"
                        checked={
                          selectedImages.includes(
                            image.id
                          )
                        }
                        onChange={() =>
                          handleSelectImage(
                            image.id
                          )
                        }
                      />

                    </div>

                    {/* ================= PHOTO DETAILS / EDIT ================= */}

                    {editingId === image.id ? (

                      <div className="media-details">

                        <div className="gallery-edit-row">

                          <label>
                            Title
                          </label>

                          <input
                            type="text"
                            name="title"
                            value={editData.title}
                            onChange={
                              handleEditChange
                            }
                          />

                        </div>

                        <div className="gallery-edit-row">

                          <label>
                            Description
                          </label>

                          <textarea
                            name="description"
                            value={
                              editData.description
                            }
                            onChange={
                              handleEditChange
                            }
                          />

                        </div>

                        <div className="gallery-edit-row">

                          <label>
                            Photo
                          </label>

                          <input
                            type="file"
                            accept="image/*"
                            onChange={
                              handleEditFileChange
                            }
                          />

                        </div>

                        <div className="gallery-edit-buttons">

                          <button
                            className="gallery-save-btn"
                            onClick={() =>
                              handleSaveEdit(
                                image.id
                              )
                            }
                          >
                            💾 Save
                          </button>

                          <button
                            className="gallery-cancel-btn"
                            onClick={
                              handleCancelEdit
                            }
                          >
                            ✖ Cancel
                          </button>

                        </div>

                      </div>

                    ) : (

                      <div className="media-details">

                        <h4>
                          {image.title}
                        </h4>

                        <p>
                          {image.description ||
                            "No description"}
                        </p>

                        <button
                          className="edit-btn"
                          onClick={() =>
                            handleEdit(image)
                          }
                        >
                          ✏️ Edit
                        </button>

                      </div>

                    )}

                  </div>

                ))}

              </div>

            </>

          )}

        </section>

      )}

      {/* ================= VIDEOS ================= */}

      {view !== "photos" && (

        <section className="gallery-section">

          <h3>🎥 Videos</h3>

          {videos.length === 0 ? (

            <p className="empty-message">
              No videos available.
            </p>

          ) : (

            <div className="manage-gallery-grid">

              {videos.map((video) => (

                <div
                  className="manage-gallery-card"
                  key={video.id}
                >

                  {/* VIDEO */}

                  <div className="media-container">

                    <video controls>

                      <source
                        src={`${video.fileUrl}`}
                        type="video/mp4"
                      />

                      Your browser does not support
                      video playback.

                    </video>

                  </div>

                  {/* ================= VIDEO DETAILS / EDIT ================= */}

                  {editingId === video.id ? (

                    <div className="media-details">

                      <div className="gallery-edit-row">

                        <label>
                          Title
                        </label>

                        <input
                          type="text"
                          name="title"
                          value={editData.title}
                          onChange={
                            handleEditChange
                          }
                        />

                      </div>

                      <div className="gallery-edit-row">

                        <label>
                          Description
                        </label>

                        <textarea
                          name="description"
                          value={
                            editData.description
                          }
                          onChange={
                            handleEditChange
                          }
                        />

                      </div>

                      <div className="gallery-edit-row">

                        <label>
                          Video
                        </label>

                        <input
                          type="file"
                          accept="video/*"
                          onChange={
                            handleEditFileChange
                          }
                        />

                      </div>

                      <div className="gallery-edit-buttons">

                        <button
                          className="gallery-save-btn"
                          onClick={() =>
                            handleSaveEdit(
                              video.id
                            )
                          }
                        >
                          💾 Save
                        </button>

                        <button
                          className="gallery-cancel-btn"
                          onClick={
                            handleCancelEdit
                          }
                        >
                          ✖ Cancel
                        </button>

                      </div>

                    </div>

                  ) : (

                    <div className="media-details">

                      <h4>
                        {video.title}
                      </h4>

                      <p>
                        {video.description ||
                          "No description"}
                      </p>

                      <button
                        className="edit-btn"
                        onClick={() =>
                          handleEdit(video)
                        }
                      >
                        ✏️ Edit
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() =>
                          handleDelete(
                            video.id,
                            "video"
                          )
                        }
                      >
                        🗑 Delete
                      </button>

                    </div>

                  )}

                </div>

              ))}

            </div>

          )}

        </section>

      )}

      {/* ================= PHOTO PREVIEW POPUP ================= */}

      {selectedPhoto && (

        <div
          className="photo-preview-overlay"
          onClick={handleClosePhoto}
        >

          <div
            className="photo-preview-box"
            onClick={(event) =>
              event.stopPropagation()
            }
          >

            {/* CLOSE */}

            <button
              className="photo-preview-close"
              onClick={handleClosePhoto}
            >
              ✕
            </button>

            {/* PREVIOUS */}

            <button
              className="photo-preview-prev"
              onClick={handlePreviousPhoto}
            >
              ‹
            </button>

            {/* PHOTO */}

            <img
              src={`${selectedPhoto.fileUrl}`}
              alt={selectedPhoto.title}
              className="photo-preview-image"
            />

            {/* NEXT */}

            <button
              className="photo-preview-next"
              onClick={handleNextPhoto}
            >
              ›
            </button>

            {/* TITLE */}

            <h3>
              {selectedPhoto.title}
            </h3>

          </div>

        </div>

      )}

    </div>

  );
}

export default ManageGallery;